// extracted by mini-css-extract-plugin
module.exports = {"bottom_menu":"BottomMenu_bottom_menu__WVyZR","menu_item":"BottomMenu_menu_item__1e1Yq","menu_item_selected":"BottomMenu_menu_item_selected__3Bz5q"};